import { Box } from '@mui/material';
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro';
import React from 'react';
import { Incident } from '../../types';

interface IncidentDataGridProps {
  incidents: ReadonlyArray<Incident>;
  columns: GridColDef[];
}

function arePropsEqual(
  prevProps: IncidentDataGridProps,
  nextProps: IncidentDataGridProps,
): boolean {
  if (prevProps.columns !== nextProps.columns) {
    return false;
  }

  if (!prevProps.incidents && !nextProps.incidents) {
    return true;
  }
  if (!prevProps.incidents || !nextProps.incidents) {
    return false;
  }

  if (prevProps.incidents.length !== nextProps.incidents.length) {
    return false;
  }

  for (let i = 0; i < prevProps.incidents.length; i++) {
    const prevIncident = prevProps.incidents[i];
    const nextIncident = nextProps.incidents[i];

    if (
      prevIncident.id !== nextIncident.id ||
      prevIncident.deviceName !== nextIncident.deviceName ||
      prevIncident.rackId !== nextIncident.rackId ||
      prevIncident.maxCellT !== nextIncident.maxCellT ||
      prevIncident.timestamp !== nextIncident.timestamp ||
      prevIncident.unitId !== nextIncident.unitId
    ) {
      return false;
    }
  }

  return true;
}

const IncidentDataGrid: React.FC<IncidentDataGridProps> = React.memo(
  ({ incidents, columns }) => {
    return (
      <Box sx={{ height: 400, width: '100%' }}>
        <DataGridPro
          rows={incidents}
          columns={columns}
          density='compact'
          disableRowSelectionOnClick
          initialState={{
            sorting: {
              sortModel: [{ field: 'timestamp', sort: 'desc' }],
            },
            pagination: {
              paginationModel: { pageSize: 25 },
            },
          }}
          pageSizeOptions={[25, 50, 100, 200]}
          pagination
          sx={{
            '& .MuiDataGrid-columnHeader': {
              fontWeight: 'bold',
            },
          }}
        />
      </Box>
    );
  },
  arePropsEqual,
);

IncidentDataGrid.displayName = 'IncidentDataGrid';

export default IncidentDataGrid;
